import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-684cd944"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold mb-2" }, " Нажмите на галочку, если хотите выбрать тариф плательщика ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large CompaniesPayers",
    title: "Плательщики",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitPayers
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_the_select, {
        class: "mt-3",
        value: _ctx.state.payer_company_ids,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.payer_company_ids) = $event)),
        placeholder: "Выберите плательщиков",
        loading: _ctx.data_state.companies.is_loading,
        options: _ctx.data_state.companies.list,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        multiselect: "",
        "infinite-scroll": "",
        onRefresh: _ctx.loadCompanies,
        onLoadmore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany,
        onLastValue: _ctx.handleSelect
      }, {
        option: _withCtx(({ option }) => [
          _createTextVNode(_toDisplayString(option.name) + " ", 1),
          (_ctx.state.payer_company_ids.includes(option.id))
            ? (_openBlock(), _createBlock(_component_checkbox, {
                key: 0,
                value: option.use_tariff,
                "onUpdate:value": ($event: any) => ((option.use_tariff) = $event),
                "return-integer": "",
                onClick: _withModifiers(($event: any) => (_ctx.handleSelectCheckbox(option)), ["stop"])
              }, null, 8, ["value", "onUpdate:value", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading", "options", "failed", "onRefresh", "onSearch", "onOptionBySearch", "onLastValue"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}